import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { PrimeTemplate } from 'primeng/api';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { Toolbar } from 'primeng/toolbar';
import { DriftsMeddelelserService } from '../driftsmeddelelser.service';

@Component({
  selector: 'app-driftsmeddelelser-list',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    TableRowDirective,
    FormsModule,
    IconField,
    InputIcon,
    InputText,
    Toolbar,
  ],
  templateUrl: './driftsmeddelelser-list.component.html',
  styleUrl: './driftsmeddelelser-list.component.css',
})
export class DriftsmeddelelserListComponent {
  driftsMeddelelserService = inject(DriftsMeddelelserService);

  data = this.driftsMeddelelserService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.driftsMeddelelserService.selectDriftsMeddelelse(e.data);
  }
}
